window.arContractDocumentNonDisclosureAgreementFormatter = function(value, row) {
    let html = '';
    html += '<a href="/ar/documents/download/'+row.document_non_disclosure_agreement.id+'" target="_blank" class="button-download-confidentiality-statement">';
    html += '<i class="fas fa-download me-2"></i>';
    html += '</a>';
    /*
    if ((row.signature_type === 'client' && row.document_non_disclosure_agreement.status_client !== 'signed')
    || (row.signature_type === 'freelancer' && row.document_non_disclosure_agreement.status_freelancer !== 'signed')) {
        html += '<a class="button-sign btn btn-success btn-sm" data-contract-id="' + row.contract_id + '" data-document-id="' + row.document_non_disclosure_agreement.id + '">';
        html += '<i class="fal fa-file-signature me-2"></i>';
        html += __('Sign');
        html += '</a>';
    }
    html += '<br>';
    */
    return html;
}
